import { DownloadFileContentModal } from "../download-file-content/download-file-content-modal.component";
import { Component } from "@angular/core";
import { ReportsService, InvoiceGroup, ApiRequestDto, ApiRequestDtoBillingHistoryOptions } from "../../api";
import { FacilitiesService } from "../../core";
import { BillingHistoryOptions } from "../../api/model/billingHistoryOptions";
import SortOrderEnum = BillingHistoryOptions.SortOrderEnum;
import { DateConversion } from "../../shared/date/date-range";
import { LoadingError, ErrorObjectTypeEnum } from "../../core/error-catching.service";
import { takeUntil, catchError } from 'rxjs/operators';

export const ALL_INVOICE_GROUP_OPTION: InvoiceGroup = {
    GroupCode: "All",
    Description: "All Invoice Groups"
}

@Component({
    selector: 'my-billing-history-modal',
    templateUrl: 'billing-history-modal.component.html',
    styleUrls: ['billing-history-modal.component.scss']
})
export class BillingHistoryModal extends DownloadFileContentModal{
    
    constructor( private reportService: ReportsService, private facilityService: FacilitiesService){
        super();
        this.maxDate = this.endDate;
    }

    reportName: string = "Billing History";
    title: string = "Download Billing History";
    searchText: string;
    filteredInvoiceGroups: InvoiceGroup[]=[];
    allInvoiceGroups: InvoiceGroup[]=[];
    selectedInvoiceGroup: InvoiceGroup;
    showDateRangeSelector: boolean = true;

    isLoadingInvoiceGroups: boolean=false;
    hideSpinner:boolean = true;

    sortOrderEnums: SortOrderEnum[];
    selectedSortOrder: SortOrderEnum = SortOrderEnum.ResidentName;

    show() {
        this.hideSpinner = true;
        this.allInvoiceGroups = null;
        this.filteredInvoiceGroups = null;
        this.isLoadingInvoiceGroups = true;
        this.selectedInvoiceGroup = ALL_INVOICE_GROUP_OPTION;
        this.selectedSortOrder = SortOrderEnum.ResidentName;

        // Explicit list to ensure order
        this.sortOrderEnums = [SortOrderEnum.ResidentName, SortOrderEnum.InvoiceGroup]
        const requestParams: ApiRequestDto = { 
            OrgList: this.facilityService.selectedAsOrgList,
        };
        this.reportService.reportsGetInvoiceGroups(requestParams)
            .pipe(takeUntil(this.stop$)).subscribe((result) => {
                result.unshift(ALL_INVOICE_GROUP_OPTION)
                this.allInvoiceGroups = result;
                this.filteredInvoiceGroups = result;
                this.isLoadingInvoiceGroups = false;
        });
        
        super.show();       
    }

    searchInvoiceGroups(value: string){
        if(value !== undefined && value !== null) {
            let lowerSearch = value.toLowerCase();

            this.filteredInvoiceGroups = this.allInvoiceGroups.filter(r => {
                let lowerCaseName = r.Description.toLowerCase();
                return lowerCaseName.indexOf(lowerSearch) >= 0;
            });
        }
    }

    selectInvoiceGroup(invoiceGroup: InvoiceGroup) {
        setTimeout(() => {
            this.selectedInvoiceGroup = invoiceGroup;
        });
    }

    getDisplayNameForEnum(sortOrder: SortOrderEnum): string{
        switch (sortOrder){
            case SortOrderEnum.ResidentName:
                return 'Resident Name';
            case SortOrderEnum.InvoiceGroup:
                return 'Invoice Group';
            default:
                return sortOrder.toString();
        }
    }

    selectSortOrder(sortOrder: SortOrderEnum){
        setTimeout(()=>{
            this.selectedSortOrder = sortOrder;
        })
    }

    canGenerateReport(): boolean {
        if (!this.isValidDateRange){
            return false;
        }
        else if (!this.selectedInvoiceGroup) {
            return false;
        }
        else if (!this.selectedSortOrder) {
            return false
        }
        else {
            return this.hideSpinner;
        }
    }

    generateContent() {
        this.hideSpinner = false;
        let invoiceGroup = this.selectedInvoiceGroup.GroupCode === ALL_INVOICE_GROUP_OPTION.GroupCode ? 
            null :this.selectedInvoiceGroup;
        
        let billingHistoryOptions : BillingHistoryOptions = {
            StartDate: DateConversion.localDateToStartOfDayJsUTC(this.dateRange.startDate),
            EndDate: DateConversion.localDateToStartOfDayJsUTC(this.dateRange.endDate),
            InvoiceGroup: invoiceGroup,
            SortOrder: this.selectedSortOrder
        };

        const requestParams: ApiRequestDtoBillingHistoryOptions = { 
            OrgList: this.facilityService.selectedAsOrgList,
            _RequestOptions: billingHistoryOptions
        };
        this.reportService.reportsGetGeneratedBillingHistoryReport(requestParams)
            .pipe(catchError((error) => {
                this.hideSpinner = true;
                throw new LoadingError(this.reportName, ErrorObjectTypeEnum.Report);
            }))
            .subscribe((result: Blob) => {
                this.downloadFile(result, "BillingHistory.xls");
                this.closeModal();
            });
    }
}